// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout5-bannerLayoutContainer-kKWYm {
    /* min-height: 158px;
    height: auto;
    position: relative;
    background: linear-gradient(180deg, #ffffff 55%, var(--primary-color) 45%);
    z-index: 999; */
    /* min-height: 768px; */
    min-height: 568px;
    height: auto;
    position: relative;
    background: var(--background-common-color);
}

.Layout5-bannerBackgroundImage-oHwst {
    background-size: cover;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    right: 0;
    -o-object-fit: cover;
       object-fit: cover;
    background-repeat: no-repeat;
    background-position: center center;
    -webkit-transition: all 0.1s ease;
    transition: all 0.1s ease;
}

.Layout5-searchFormContainer-hmKqv {
    position: relative;
    height: 100%;
    margin: 0 auto;
    width: 85%;
    /* max-width: 1250px; */
    padding: 10px 15px 0px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
}

.Layout5-bannerCaptionText-CQEKR {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 15px;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    font-size: 48px !important;
    /* line-height: 65px; */
    padding-top: 0px;
    font-family: var(--font-family-primary) !important;
    color: #ffffff !important;
    font-weight: bold;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);
    text-align: center;
    background: transparent;
    padding: 12px 24px;
    border-radius: 12px;
    display: inline-block;
}

/* .liquidglass {
    background: rgba(255, 255, 255, 0.12) !important;
    backdrop-filter: blur(16px) saturate(180%);
    -webkit-backdrop-filter: blur(16px) saturate(180%);
    border: 1px solid rgba(255, 255, 255, 0.25);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.2);
} */

.Layout5-bannerContentText-I_B5P {
    font-family: var(--font-family-base) !important;
    font-size: 20px;
    color: #ffffff !important;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);
    font-weight: bold;
    text-align: center;
    background: transparent;
    padding: 10px 22px;
    border-radius: 12px;
    display: inline-block;
}

.Layout5-bannerCaptionHighlight-lHD9v {
    font-weight: 700;
    color: var(--primary-bg);
}

.Layout5-imageCss-KlRXN {
    width: 100%;
    border-radius: 15px;
    margin-top: 35px;
}

.Layout5-logoAboveSearch-rV7aS {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    margin: 70px auto 0px auto;
    
}

.Layout5-searchRow-lq_sQ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    margin-top: auto;
    margin-bottom: auto;
}

.Layout5-sideImage-O1_Ln {
    width: 100px;
    height: 100px;
    -webkit-transform: translateX(1vw);
        -ms-transform: translateX(1vw);
            transform: translateX(1vw);
    left: 0;
    position: absolute;
}

.Layout5-searchMiddle-Ufbdg {
    margin: 5px auto;
    -webkit-box-flex: 1;
        -ms-flex: 1 1;
            flex: 1 1;
   /*  max-width: 600px; */
}

.Layout5-positionRelative-PZ29Y {
    position: relative;
}

@media screen and (min-width: 1300px) {
    .Layout5-searchFormContainer-hmKqv {
        padding-top: 110px;
    }
}

@media screen and (max-width: 1200px) {
    .Layout5-bannerCaptionText-CQEKR {
        padding-top: 50px;
    }
}

@media screen and (max-width: 767px) {
    .Layout5-searchFormWrap-raJZn {
        padding: 20px;
    }

    .Layout5-bannerCaptionText-CQEKR {
        font-size: 24px;
        line-height: 30px;
        bottom: initial;
        padding-top: 20px;
        padding: 10px 16px;
    }

    .Layout5-sideImage-O1_Ln {
        width: 60px;
        height: 60px;
    }

    .Layout5-searchFormContainer-hmKqv {
        padding: 30px 15px 100px;
    }

    .Layout5-searchRow-lq_sQ {
        gap: 10px;
    }

    .Layout5-bannerLayoutContainer-kKWYm {
        background: -webkit-gradient(linear, left top, left bottom, color-stop(50%, #ffffff), color-stop(50%, var(--primary-color)));
        background: linear-gradient(180deg, #ffffff 50%, var(--primary-color) 50%);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/Layout5/Layout5.css"],"names":[],"mappings":"AAAA;IACI;;;;mBAIe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,oBAAiB;OAAjB,iBAAiB;IACjB,4BAA4B;IAC5B,kCAAkC;IAClC,iCAAyB;IAAzB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,UAAU;IACV,uBAAuB;IACvB,sBAAsB;IACtB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;AAC1B;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,SAAS;IACT,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,0BAA0B;IAC1B,uBAAuB;IACvB,gBAAgB;IAChB,kDAAkD;IAClD,yBAAyB;IACzB,iBAAiB;IACjB,yCAAyC;IACzC,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;;;;;GAMG;;AAEH;IACI,+CAA+C;IAC/C,eAAe;IACf,yBAAyB;IACzB,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,0BAA0B;;AAE9B;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kCAA0B;QAA1B,8BAA0B;YAA1B,0BAA0B;IAC1B,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAO;QAAP,aAAO;YAAP,SAAO;GACR,uBAAuB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,4HAA0E;QAA1E,0EAA0E;IAC9E;AACJ","sourcesContent":[".bannerLayoutContainer {\n    /* min-height: 158px;\n    height: auto;\n    position: relative;\n    background: linear-gradient(180deg, #ffffff 55%, var(--primary-color) 45%);\n    z-index: 999; */\n    /* min-height: 768px; */\n    min-height: 568px;\n    height: auto;\n    position: relative;\n    background: var(--background-common-color);\n}\n\n.bannerBackgroundImage {\n    background-size: cover;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    position: absolute;\n    right: 0;\n    object-fit: cover;\n    background-repeat: no-repeat;\n    background-position: center center;\n    transition: all 0.1s ease;\n}\n\n.searchFormContainer {\n    position: relative;\n    height: 100%;\n    margin: 0 auto;\n    width: 85%;\n    /* max-width: 1250px; */\n    padding: 10px 15px 0px;\n    display: flex;\n    flex-direction: column;\n}\n\n.bannerCaptionText {\n    display: flex;\n    gap: 15px;\n    justify-content: center;\n    align-items: center;\n    font-size: 48px !important;\n    /* line-height: 65px; */\n    padding-top: 0px;\n    font-family: var(--font-family-primary) !important;\n    color: #ffffff !important;\n    font-weight: bold;\n    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);\n    text-align: center;\n    background: transparent;\n    padding: 12px 24px;\n    border-radius: 12px;\n    display: inline-block;\n}\n\n/* .liquidglass {\n    background: rgba(255, 255, 255, 0.12) !important;\n    backdrop-filter: blur(16px) saturate(180%);\n    -webkit-backdrop-filter: blur(16px) saturate(180%);\n    border: 1px solid rgba(255, 255, 255, 0.25);\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.2);\n} */\n\n.bannerContentText {\n    font-family: var(--font-family-base) !important;\n    font-size: 20px;\n    color: #ffffff !important;\n    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);\n    font-weight: bold;\n    text-align: center;\n    background: transparent;\n    padding: 10px 22px;\n    border-radius: 12px;\n    display: inline-block;\n}\n\n.bannerCaptionHighlight {\n    font-weight: 700;\n    color: var(--primary-bg);\n}\n\n.imageCss {\n    width: 100%;\n    border-radius: 15px;\n    margin-top: 35px;\n}\n\n.logoAboveSearch {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin: 70px auto 0px auto;\n    \n}\n\n.searchRow {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.sideImage {\n    width: 100px;\n    height: 100px;\n    transform: translateX(1vw);\n    left: 0;\n    position: absolute;\n}\n\n.searchMiddle {\n    margin: 5px auto;\n    flex: 1;\n   /*  max-width: 600px; */\n}\n\n.positionRelative {\n    position: relative;\n}\n\n@media screen and (min-width: 1300px) {\n    .searchFormContainer {\n        padding-top: 110px;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .bannerCaptionText {\n        padding-top: 50px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .searchFormWrap {\n        padding: 20px;\n    }\n\n    .bannerCaptionText {\n        font-size: 24px;\n        line-height: 30px;\n        bottom: initial;\n        padding-top: 20px;\n        padding: 10px 16px;\n    }\n\n    .sideImage {\n        width: 60px;\n        height: 60px;\n    }\n\n    .searchFormContainer {\n        padding: 30px 15px 100px;\n    }\n\n    .searchRow {\n        gap: 10px;\n    }\n\n    .bannerLayoutContainer {\n        background: linear-gradient(180deg, #ffffff 50%, var(--primary-color) 50%);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerLayoutContainer": `Layout5-bannerLayoutContainer-kKWYm`,
	"bannerBackgroundImage": `Layout5-bannerBackgroundImage-oHwst`,
	"searchFormContainer": `Layout5-searchFormContainer-hmKqv`,
	"bannerCaptionText": `Layout5-bannerCaptionText-CQEKR`,
	"bannerContentText": `Layout5-bannerContentText-I_B5P`,
	"bannerCaptionHighlight": `Layout5-bannerCaptionHighlight-lHD9v`,
	"imageCss": `Layout5-imageCss-KlRXN`,
	"logoAboveSearch": `Layout5-logoAboveSearch-rV7aS`,
	"searchRow": `Layout5-searchRow-lq_sQ`,
	"sideImage": `Layout5-sideImage-O1_Ln`,
	"searchMiddle": `Layout5-searchMiddle-Ufbdg`,
	"positionRelative": `Layout5-positionRelative-PZ29Y`,
	"searchFormWrap": `Layout5-searchFormWrap-raJZn`
};
module.exports = ___CSS_LOADER_EXPORT___;
